import * as plansActions from '../../../InsuranceForm/plans';
import { carrierSelector } from '../carrier';
import dropdownStateSelector from '../dropdown-state/dropdownStateSelector';
import { get } from 'lodash';

export function fetchPlansIfNeeded() {
    return (dispatch, getState) => {
        const state = getState();
        const carrierId = carrierSelector(state);
        return plansActions.fetchPlansIfNeeded(carrierId)(dispatch, getState);
    };
}

// This is called via the dropdownStateActions in the insurance picker, when the dropdown opens on click
export function fetchPlansIfNeededDropdown() {
    return (dispatch, getState) => {
        const state = getState();
        const selector = dropdownStateSelector(state);
        const carrierId = get(selector, 'carrier.id');
        return plansActions.fetchPlansIfNeeded(carrierId)(dispatch, getState);
    };
}
